import { ca } from '@cian/analytics';

import { TJsonQuery } from '../../../../packages/JsonQuery';

type TProduct = {
  id: number;
  offerType: 'offer';
  position: number;
};

export function trackOfferClick(id: number, position: number, jsonQuery: TJsonQuery) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'PeretokCarousel',
    action: 'click',
    label: 'Offer',
    sc: jsonQuery,
    page: {
      listingType: 'list',
      pageType: 'List',
      pageNumber: 1,
    },
    products: [
      {
        id,
        offerType: 'offer',
        position,
      },
    ],
  });
}

export function trackOffersShow(products: TProduct[], jsonQuery: TJsonQuery) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'PeretokCarousel',
    action: 'show',
    label: 'Listing',
    sc: jsonQuery,
    page: {
      listingType: 'list',
      pageType: 'List',
      pageNumber: 1,
    },
    products,
  });
}

export function trackAllClick(products: TProduct[], jsonQuery: TJsonQuery) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'PeretokCarousel',
    action: 'click',
    label: 'All',
    sc: jsonQuery,
    page: {
      listingType: 'list',
      pageType: 'List',
      pageNumber: 1,
    },
    products,
  });
}
